export const SetupSettings = async function(modules: IDigitalIdentityHubModule[]): Promise<void> {
  // Check for settings. If there are none, create them
  if (typeof window.janrain !== "object") {
    (window as Window).janrain = {} as IJanrain;
  }
  if (typeof window.janrain.settings !== "object") {
    window.janrain.settings = {} as IJanrainSettings;
  }
  if (typeof window.janrain.settings.capture !== "object") {
    window.janrain.settings.capture = {} as IJanrainSettingsCapture;
  }

  window.GIT_VERSION = process.env.GIT_VERSION;

  // Load Engage and Capture. 'login' is Engage, 'capture' is Capture.
  // Changing these values without guidance can result in unexpected behavior.
  janrain.settings.packages = ["login", "capture"];

  // --- Engage Widget Settings ----------------------------------------------
  // THIS IS PROBABLY FOR SOCIAL LOGIN
  // janrain.settings.language = 'en-US';

  janrain.settings.tokenUrl = document.location.protocol === "https:" ? "https://localhost/" : "http://localhost/";
  janrain.settings.tokenAction = "event";
  janrain.settings.showAttribution = false;
  janrain.settings.borderColor = "#ffffff";
  janrain.settings.fontFamily = "Helvetica, Lucida Grande, Verdana, sans-serif";
  janrain.settings.width = 300;
  janrain.settings.actionText = " ";
  janrain.settings.custom = true;

  // --- Capture Widget Settings ---------------------------------------------

  janrain.settings.capture.setProfileCookie = true;
  janrain.settings.capture.keepProfileCookieAfterLogout = false;
  janrain.settings.capture.modalCloseHtml = "X";
  janrain.settings.capture.noModalBorderInlineCss = true;
  janrain.settings.capture.noStyling = false;
  janrain.settings.capture.profileUpdatedEmailConfigured = false;
  janrain.settings.capture.responseType = "token";
  janrain.settings.capture.returnExperienceUserData = ["displayName"];
  // Setting SSO false in case of Safari users where current screen is resetPasswordRequestCode or verifyEmail
  // Due to Safari SSO limitation a extra redirection is getting done which is hitting reset password url twice
  const url = window.location.href;
  janrain.settings.capture.federate =
    !((url.includes("resetPasswordRequestCode") || url.includes("preregCreatePasswordRequestCode") || url.includes("verifyEmail")) && window.DigitalIdentityHub.utilities.isSafari());

  // --- Hidden Required screen ----------------------------------------------
  // Hack for hidden emailVerificationRequired screen after registration
  janrain.settings.capture.ignoreEmailVerificationRequiredScreen = "false";

  /*--
    SCREEN TO RENDER:
    This setting defines which screen to render. We've set it to the result
    of implFuncs.getParameterByName() so that if you pass in a parameter
    in your URL called 'screenToRender' and provide a valid screen name,
    that screen will be shown when the Widget loads.
    --*/
  janrain.settings.capture.screenToRender = window.DigitalIdentityHub.utilities.getParameterByName("screenToRender");

  const promises = [];

  // Modules
  for (const m of modules) {
    try {
      promises.push(m.init());
    } catch (e) {
      console.log("Failed to load module (init):", m.name, "error:", e);
    }
  }

  await Promise.all(promises);
};
